// src/components/FontFamilySelect.jsx
import React from 'react';
import CustomSelect from './CustomSelect';
import { fontList } from '../resources/fontList'; // Adjust the import path as needed

const FontFamilySelect = ({ selectedFontFamily, onFontFamilyChange }) => {
  return (
    <CustomSelect
      labelId="font-family-select"
      id="font-family-select"
      selectValue={selectedFontFamily}
      selectLabel="Font Family"
      selectOnChange={onFontFamilyChange}
      menuItems={fontList}
    />
  );
};

export default FontFamilySelect;
